import React from 'react'
import { colors, cssFont, media } from '../../constants/style'
import { Column, Row } from '../UI/Grid'

const Wrapper = Row.extend`
  padding: 20px 40px;
  justify-content: flex-end;

  ${media.medium`
    padding: 0 40px;
  `} a {
    text-decoration: none;
    margin-left: 10px;
  }
`

const IconWrapper = Column.extend`
  width: 40px;
  height: 40px;
  svg {
    width: 100%;
  }
`

const Inner = Row.extend`
  ${cssFont.text} text-decoration: none;
  align-items: center;
  justify-content: center;
  font-weight: 100;
`

const Icon = () => (
  <IconWrapper>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 187.1 168">
      <path
        fill={colors.red}
        d="M124.2 76.5l-27.1 39.1h-7L62.9 76.5v-4.7h14.2l.3-38.7h32.7v38.7h14.1zM40.2 123.1h106.7v11.7H40.2z"
      />
    </svg>
  </IconWrapper>
)

const Downloads = () => (
  <Wrapper>
    <a href="/PACTASALONE_Cartellastampa_020-021_cop.pdf" download>
      <Inner>
        <Icon />
        Cartella Stampa
      </Inner>
    </a>

    <a href="/Locandina_stag_20_21_21x49_HR.pdf" download>
      <Inner>
        <Icon />
        Depliant
      </Inner>
    </a>
  </Wrapper>
)

export default Downloads



// WEBPACK FOOTER //
// ./src/components/Downloads/index.js